import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextareaAutosize,
  Typography,
  MenuItem,
  Select,
  TextField,
  FormControl,
  IconButton, Table, TableBody, TableCell, TableContainer, TableRow, Paper, styled
} from "@mui/material";
import { useContext, useEffect, useRef, useState, useMemo, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Chat from "../Workstream/Chat";
import { Button, FileUpload, FileViewer } from "../components";
import { ArrowBackIos as ArrowBackIosIcon, DeleteForever, Edit, OpenInNew, Download } from "@mui/icons-material";
import {
  fetchDelete,
  fetchGet,
  fetchPost,
  fetchPut,
  convertDate,
  getBase64,
  transformFirebaseTime,
  fetchFile
} from "../util/helpers";
import Analytics from "../Workstream/Analytics";
import UserContext from "../contexts/UserContext";
import LoadingContext from "../contexts/LoadingContext";
import toast, { Toaster } from "react-hot-toast";
import { DataGrid } from "@mui/x-data-grid";



import { registerLicense } from '@syncfusion/ej2-base';
import { DocumentEditorContainerComponent, Toolbar, SfdtExport, WordExport } from '@syncfusion/ej2-react-documenteditor';
registerLicense("Ngo9BigBOggjHTQxAR8/V1NAaF1cVGhIfEx1RHxQdld5ZFRHallYTnNWUj0eQnxTdEFjUX5acXdWQ2NVWUJ/Ww==")
DocumentEditorContainerComponent.Inject(Toolbar, SfdtExport, WordExport);
const initialPostList = {
  link: "",
  platform: ""
}

const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-input': {
    padding: '0px 5px', // Adjust padding to match table cell padding
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none', // Remove the border
  },
});

const StyledSelect = styled(Select)({
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiSelect-select': {
    padding: '5px',
  },
});


const StyledTable = styled(Table)(({ theme }) => ({
  border: `2px solid ${theme.palette.grey[400]}`
}))

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderRight: `2px solid ${theme.palette.grey[400]}`,
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:last-child td, &:last-child th': { borderBottom: 0 },
  borderBottom: `2px solid ${theme.palette.grey[400]}`,
}));

const TableFields = [{ key: "view_count", label: "View Count" }, { key: "like_count", label: "Number of Likes" }, { key: "comment_count", label: "Number of Comments" }, { key: "share_count", label: "Number of Shares" }]
const initialNewPostAnalytics = { platform: "", view_count: "", like_count: "", comment_count: "", share_count: "" }

export default function CreatorsWorkstream() {
  const [campaign, setCampaign] = useState({});
  const { setIsLoading } = useContext(LoadingContext);
  const [products, setProducts] = useState([]);
  const [concept, setConcept] = useState({ platform: "concept", link: "" });
  const [newConceptLink, setNewConceptLink] = useState("");
  const [deliverable, setDeliverable] = useState([]);
  const [newDeliverableLink, setNewDeliverableLink] = useState("");
  const [brief, setBrief] = useState("");
  const [agreement, setAgreement] = useState("");
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const editorMutableRef = useRef();
  const { campaignId } = useParams();
  const { user } = useContext(UserContext);
  const briefInterval = useRef();
  const [postLinkModal, setPostLinkModal] = useState(false);
  const [postLinkData, setPostLinkData] = useState({ ...initialPostList });
  const [postLinkList, setPostLinkList] = useState([]);
  const [newPostAnalytics, setNewPostAnalytics] = useState({ ...initialNewPostAnalytics });
  const [postAnalyticsData, setPostAnalyticsData] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [deliverableOpen, setDeliverableOpen] = useState(false);
  const [deliverableFormData, setDeliverableFormData] = useState({ file: "", caption: "" });
  const descriptionStyle = {
    maxHeight: showMore ? 'none' : '6em',
    overflow: 'hidden',
    transition: 'max-height .5s ease-in-out'
  };
  const [approveContent, setApproveContent] = useState(false);
  const [approveConcept, setApproveConcept] = useState(false);
  const [feedbackList, setFeedbackList] = useState([]);
  const onLoadDefault = (ref) => {
    // tslint:disable
    let defaultDocument = {
      sfdt: "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",
    };
    // tslint:enable
    ref.documentEditor.open(JSON.stringify(defaultDocument));
    ref.documentEditor.documentName = "Invoice";
    ref.documentChange = () => {
      ref.documentEditor.focusIn();
    };
  };
  const columns = useMemo(
    () => [
      {
        field: "srNo", headerName: "Sr. No", width: 70, valueGetter: (params) => {
          const rowIndex = params?.api?.getAllRowIds()?.indexOf(params?.id?.toString());
          return rowIndex + 1;
        }
      },
      { field: "platform", headerName: "Platform" },
      { field: "link", headerName: "Link", flex: 1, renderCell: (params) => [<a href={params.value} target="_blank" style={{ color: "black", textDecoration: "none" }}>{params.value}</a>] },
      {
        field: "actions",
        type: "actions",
        width: 400,
        sortable: false,
        getActions: (params) => [
          <a href={params.row.link} target="_blank" style={{ color: "black", textDecoration: "none" }}>
            <IconButton
              style={{
                backgroundColor: "#4158D0",
                backgroundImage:
                  "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)",
                borderRadius: 20,
                fontSize: 14,
              }}
              onClick={() => {
              }}
            >
              <OpenInNew />
            </IconButton></a>,
          <IconButton
            style={{
              backgroundColor: "#4158D0",
              backgroundImage:
                "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)",
              borderRadius: 20,
              fontSize: 14,
            }}
            onClick={() => {
              setPostLinkModal(true);
              setPostLinkData(params.row)
            }}
          >
            <Edit />
          </IconButton>,
          <IconButton
            style={{
              backgroundColor: "#4158D0",
              backgroundImage:
                "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)",
              borderRadius: 20,
              fontSize: 14,
            }}
            onClick={() => {
              deleteDeliverables(params.row.id)
            }}
          >
            <DeleteForever />
          </IconButton>,
        ],
      }]
  );

  const analyticsColumns = useMemo(() => [
    {
      field: "srNo", headerName: "Sr. No", width: 70, valueGetter: (params) => {
        const rowIndex = params?.api?.getAllRowIds()?.indexOf(params?.id?.toString());
        return rowIndex + 1;
      }
    },
    {
      field: "platform", headerName: "Platform", flex: 1, valueGetter: (params) => {
        return valueToLabelMap[params.value]
      }
    },
    { field: "view_count", headerName: "View Count", flex: 1 },
    { field: "like_count", headerName: "Number of Likes", flex: 1 },
    { field: "comment_count", headerName: "Number of Comments", flex: 1.5 },
    { field: "share_count", headerName: "Number of Shares", flex: 1 },
    {
      field: "actions",
      type: "actions",
      width: 150,
      sortable: false,
      getActions: (params) => [
        <IconButton
          style={{
            backgroundColor: "#4158D0",
            backgroundImage:
              "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)",
            borderRadius: 20,
            fontSize: 14,
          }}
          onClick={() => {
            setNewPostAnalytics(params.row)
          }}
        >
          <Edit />
        </IconButton>,
        <IconButton
          style={{
            backgroundColor: "#4158D0",
            backgroundImage:
              "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)",
            borderRadius: 20,
            fontSize: 14,
          }}
          onClick={() => {
            deleteAnalytics(params.row.id)
          }}
        >
          <DeleteForever />
        </IconButton>,
      ],
    }
  ])
  const editorRef = useCallback(
    (ref) => {
      const rendereComplete = () => {
        editorMutableRef.current = ref;
        ref.documentEditor.pageOutline = "#E0E0E0";
        ref.documentEditor.acceptTab = true;
        ref.documentEditor.resize();
        onLoadDefault(ref);
      };
      console.log("useeffect", invoiceModalOpen, ref);
      if (invoiceModalOpen && ref) {
        rendereComplete();
      }
    },
    [invoiceModalOpen],
  );
  const clearCheckingInterval = () => {
    clearInterval(briefInterval.current);
  };

  const navigate = useNavigate();

  const getAllDeliverables = async () => {
    const results = await fetchGet(
      `/brand/deliverables?campaignId=${campaignId}&deliveredBy=${user.userDocId}`, setIsLoading
    );
    if (results.result) {
      const postLink = [];
      const deliverables = [];

      results.result.forEach((item) => {
        if (item.platform === "creator-agreement") {
          setAgreement(item);
        }
        else if (item.platform === "creator-brief") {
          setBrief(item);
        }
        else if (item.platform === "concept") {
          setConcept(item);
          setNewConceptLink(item.link);
        } else if (item.platform === "draft") {
          deliverables.push({ ...item })
        } else {
          postLink.push(item);
        }
      });
      setPostLinkList([...postLink]);
      deliverables.sort((a, b) => transformFirebaseTime(a.submittedAt) - transformFirebaseTime(b.submittedAt))
      setDeliverable([...deliverables])
    }
  };

  const getBrandDeliverables = async () => {
    const results = await fetchGet(
      `/brand/deliverables?campaignId=${campaignId}&deliveredBy=${campaign.userDocId}`,
    );
    if (results.result) {
      const tempFeedbackList = [];
      results.result.forEach((item) => {
        if (item.platform === "creator-agreement") {
          setAgreement(item.link);
        } else if (item.platform === "creator-brief") {
          setBrief(item.link);
        } 
      });
      const creatorReviews = results.result.filter((data)=>data.creatorId !== undefined && data.creatorId === user.userDocId);
      if(creatorReviews.length > 0){
        creatorReviews.forEach((item)=>{
          if (item.platform === "Approve-Content")setApproveContent(item.approved);
          else if(item.platform === "Approve-Concept")setApproveConcept(item.approved); 
          else if (item.platform === "Creator-Feedback") {
            tempFeedbackList.push({ ...item, submittedAt: new Date(item.submittedAt._seconds * 1000 + item.submittedAt._nanoseconds / 1000000) });
          }
        })
      }else{
        setApproveContent({approved:false});
        setApproveConcept({approved:false});
      }
      tempFeedbackList.sort((a,b)=>b.submittedAt - a.submittedAt)
      setFeedbackList([...tempFeedbackList]);
    }

  }

  const postDeliverables = async ({ platform, link }) => {
    try {
      await fetchPost("/creator/deliverables", {
        platform,
        link,
        campaignId
      })
    } catch (e) {
      throw new Error(e)
    }
  }

  const fetchCampaign = async () => {
    if (campaignId) {
      const response = await fetchGet(`/brand/campaigns/${campaignId}`);
      if (response.result) {
        setCampaign(response.result);
      }
    }
  };

  const fetchProducts = async () => {
    if (campaignId) {
      const results = await fetchGet(
        `/creator/redirect?campaignId=${campaignId}&creatorUserDocId=${user.userDocId}`,
      );
      setProducts(results.result);
    }
  };

  const fetchAnalytics = async () => {
    try {
      if (campaignId) {
        const results = await fetchGet(
          `/creator/metrics/${campaignId}`,
        );
        setPostAnalyticsData(results.result);
      }
    } catch (e) {
      console.log(e);
    }

  }

  const resetFields = () => {
    setAgreement("");
    setNewConceptLink(concept.link);
    setNewDeliverableLink(deliverable.link);
  };

  useEffect(() => {
    resetFields();
    if (user) {
      fetchCampaign();
      fetchProducts();
      fetchAnalytics();
    }
  }, [campaignId, user]);

  useEffect(() => {
    if (campaign) {
      getAllDeliverables();
      getBrandDeliverables();
    }
  }, [campaign])

  const handleDownloadInvoice = () => {
    if (editorMutableRef.current) {
      editorMutableRef.current.documentEditor.save("invoice", "Docx");
    }
  };

  const handlePostLinkChange = (key, value) => {
    setPostLinkData({ ...postLinkData, [key]: value });
  }

  const putDeliverables = async (postData) => {
    try {
      await fetchPut(
        `/creator/deliverables`,
        {
          ...postData,
        },
        setIsLoading,
      );
    } catch (e) {
      throw new Error(e)
    }
  }

  const deleteDeliverables = async (id) => {
    try {
      await fetchDelete(`/creator/deliverables/${id}`, setIsLoading);
      toast.success(
        `Successfully post deleted`,
      );
      getAllDeliverables();
    } catch (err) {
      toast.error("Something went wrong, please try again later");
    }
  }

  const submitPost = async () => {
    try {
      if (!postLinkData.id) await postDeliverables({ ...postLinkData });
      else await putDeliverables({ ...postLinkData });
      toast.success(
        `Successfully post ${!postLinkData.id ? "added" : "updated"}!`,
      );
      handleClosePostLinkModal();
      getAllDeliverables();
    } catch (err) {
      toast.error("Something went wrong, please try again later");
    }
  }

  const handleClosePostLinkModal = () => {
    setPostLinkData({ ...initialPostList });
    setPostLinkModal(false);

  }

  const handelUpdate = async (platform, newData={}) => {
    const body = platform == "draft" ? { ...newData, platform } : { ...concept, link: newConceptLink, platform };
    try {
      if (body.id) await putDeliverables({ ...body })
      else await postDeliverables({ ...body });
      toast.success("Successfully updated your data!");
      getAllDeliverables();
    } catch (e) {
      toast.error("Something went wrong, please try again later");

    }

  }

  const handleSubmitAnalytics = async () => {
    try {
      if (newPostAnalytics["id"]) {
        await fetchPut(
          `/creator/metrics`,
          {
            ...newPostAnalytics,
          },
          setIsLoading,
        );
      } else {
        await fetchPost("/creator/metrics", { ...newPostAnalytics, campaignId }, setIsLoading);
      }
      toast.success(`Post Analytics ${newPostAnalytics["id"] ? "updated" : "submitted"} successfully !`);
      setNewPostAnalytics({ ...initialNewPostAnalytics });
      await fetchAnalytics();
    } catch (e) {
      console.log(e);
      toast.error("Something went wrong, Please try again !");
    }
  }

  const deleteAnalytics = async (id) => {
    try {
      await fetchDelete(`/creator/metrics/${id}`, setIsLoading);
      toast.success(
        `Successfully analytics deleted`,
      );
      fetchAnalytics();
    } catch (err) {
      toast.error("Something went wrong, please try again later");
    }
  }

  const platforms = [
    { label: 'TikTok', value: 'tiktok' },
    { label: 'YouTube', value: 'youtube' },
    { label: 'Instagram', value: 'instagram' },
    { label: 'X (Formerly Twitter)', value: 'x' },
    { label: 'LinkedIn', value: 'linkedin' },
  ];

  const valueToLabelMap = platforms.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
  }, {});

  const handleToggleShowMore = () => {
    setShowMore(!showMore);
  };

  const closeDeliverablesModal = () => {
    setDeliverableFormData({});
    setDeliverableOpen(false)
  }

  const submitDeliverables = async (e) => {
    e.preventDefault();
    try {
      if (deliverableFormData.file == "" || !deliverableFormData.file) toast.error("Please, Selecte Suitable File For Your Deliverables!")
      const data = await getBase64(deliverableFormData.file);
      const imageData = { blob: data, format: deliverableFormData.file.name.split('.').pop() }
      if (deliverableFormData.id) {
        await fetchPut("/creator/deliverables", { ...deliverableFormData, file: imageData }, setIsLoading);
      } else {
        await fetchPost("/creator/deliverables", { ...deliverableFormData, file: imageData, platform: "draft", campaignId }, setIsLoading);
      }
      toast.success(`Deliverables ${deliverableFormData.id ? "updated" : "added"} Successfully!`)
      closeDeliverablesModal();
      getAllDeliverables();

    } catch (e) {
      toast.error("Please, try again. Something went wrong.")
    }
  }

  const handleDeliverableChange = (name, value) => {
    setDeliverableFormData({ ...deliverableFormData, [name]: value });
  }

  const handleDownloadDeliverables = async (fileUrl, fileName) => {
    const sourceFile = await fetchFile(fileUrl);
    const url = window.URL.createObjectURL(sourceFile);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

  }

  const assignEditableDeliverables = async (data) => {

    if (data.file) {
      data.file = await fetchFile(data.file);

    }

    setDeliverableFormData({ ...data });
    setDeliverableOpen(true);
  }

  return (

    <Box marginBottom={10}>
      <Toaster
        position="top-center"
        toastOptions={{ duration: 3000 }}
        style={{ width: 5000 }}
      />
      <Dialog
        open={deliverableOpen}
        fullWidth
        onClose={() => closeDeliverablesModal()}
        maxWidth="sm"
      >
        <DialogTitle style={{ textAlign: "center", fontWeight: 600, fontSize: "1.5rem" }}>Submit Deliverable</DialogTitle>
        <DialogContent>
          <form onSubmit={submitDeliverables}>
            <Typography
              variant="subtitle1"
              style={{
                fontWeight: 800,
                textAlign: "left",
                marginTop: 20,
              }}
            >
              Upload Content
            </Typography>
            <Typography
              variant="subtitle1"
              style={{
                textAlign: "left",
                marginBottom: 10,
              }}
            >
              (One content piece at a time)
            </Typography>
            <FileUpload
              name="file"
              handleFilesChange={(files) => {
                if (files[0]) handleDeliverableChange("file", files[0]);
              }}
              acceptedType={["image/*", "application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "video/*"]}
            />

            <Typography
              variant="subtitle1"
              style={{
                fontWeight: 800,
                textAlign: "left",
                marginTop: 20,
              }}
            >
              Outlined Caption
            </Typography>
            <Typography
              variant="subtitle1"
              style={{
                textAlign: "left",
                marginBottom: 10,
              }}
            >
              (Ensure relevant mentions/hashtags are included)
            </Typography>
            <TextareaAutosize
              minRows={5}
              required
              name="caption"
              style={{ width: "100%" }}
              onChange={(e) => handleDeliverableChange(e.target.name, e.target.value)}
              value={deliverableFormData.caption}
            ></TextareaAutosize>
            <div style={{ width: "100%", textAlign: "center", paddingTop: 20 }}>
              <Button type="submit" style={{ width: 200 }}>{`${deliverableFormData.id ? "Update" : "Submit"}`}</Button>

            </div>
          </form>

        </DialogContent>

      </Dialog>
      <Dialog
        open={invoiceModalOpen}
        fullWidth
        onClose={() => setInvoiceModalOpen(false)}
        maxWidth="lg"
      >
        <DialogTitle>Generate an invoice with our template</DialogTitle>
        <DialogContent sx={{ height: "80vh" }}>
          <DocumentEditorContainerComponent 
          ref={editorRef}
          id={`doc-editor`} height={`${window.innerHeight * 0.7}px`} style={{ 'width': '100%' }} serviceUrl="https://ej2services.syncfusion.com/production/web-services/api/documenteditor/" enableToolbar={true}
          enableWordExport
          locale="en-US"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDownloadInvoice}>Download</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={postLinkModal}
        fullWidth
        onClose={handleClosePostLinkModal}
      >
        <DialogTitle>Submit your live post link</DialogTitle>
        <DialogContent>
          <FormControl
            sx={{ marginRight: 1, minWidth: 200, }}
          >
            <Typography>Post Platform</Typography>
            <Select
              value={postLinkData.platform}
              variant="outlined"
              autoWidth
              placeholder="Select Platform"
              name="platform"
              onChange={(e) => handlePostLinkChange(e.target.name, e.target.value)}
            >
              {
                platforms.map((platform) => <MenuItem value={platform.value}>{platform.label}</MenuItem>)
              }
            </Select>
          </FormControl>

          <Typography
            variant="subtitle1"
            style={{
              fontWeight: 800,
              textAlign: "left",
              marginTop: 20,
              marginBottom: 10,
            }}
          >
            Your Post URL
          </Typography>
          <TextField
            fullWidth
            value={postLinkData.link}
            name="link"
            onChange={(e) => handlePostLinkChange(e.target.name, e.target.value)}
          ></TextField>

        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => { submitPost() }}
          >{`${postLinkData.id ? "Update " : "Add"}`}  Link</Button>
        </DialogActions>
      </Dialog>
      <div
        style={{
          width: "100%",
          height: "100%",
          background: "black",
          textAlign: "left",
          color: "white",
          paddingTop: 10,
          paddingBottom: 10,
        }}
      >
        <Typography
          variant="h2"
          component="div"
          style={{ color: "white", marginLeft: "10vw" }}
        >
          {`${campaign.brand} x ${user.name}`}
        </Typography>
      </div>
      {/* <Button
        variant="text"
        style={{ color: "black", float: "left", marginLeft: 20 }}
        onClick={() => {navigate(`/creators`)}}
      >
        <ArrowBackIosIcon />
        Back to your dashboard
      </Button> */}
      <Grid container spacing={2} style={{ marginTop: 20 }}>
        {/* Left Grid */}
        <Grid item xs={4}>
          <Chat
            style={{ width: "100%", marginLeft: 20, marginBottom: 40 }}
            campaignId={campaignId}
            creatorId={user.userDocId}
          />

          {/* <Grid
            container
            sx={{
              margin: "0 auto",
              textAlign: "center",
            }}
            alignItems="center"
            justifyContent="center"
            style={{
              backgroundColor: "black",
              minHeight: 10,
              marginTop: 50,
              marginBottom: 50,
              marginLeft: 18,
            }}
          ></Grid> */}

          {/* <Typography
            variant="h5"
            style={{
              textAlign: "left",
              marginTop: 40,
              fontWeight: 800,
              marginLeft: 20,
              marginBottom: 10,
            }}
          >
            Skip the Paperwork, Powered by AI
          </Typography>

          <Typography
            variant="body"
            style={{ textAlign: "left", marginLeft: 20, marginBottom: 40 }}
          >
            Generate Custom Documents on Gigl.
          </Typography>

          <Button
            onClick={() => setInvoiceModalOpen(true)}
            style={{
              borderRadius: 1,
              width: "90%",
              marginBottom: 10,
              marginLeft: 20,
              fontSize: 14,
              borderRadius: 6,
              marginTop: 20,
              backgroundColor: "#4158D0",
              backgroundImage:
                "linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%)",
            }}
          >
            Generate Invoice
          </Button> */}
        </Grid>

        {/* Right Grid */}
        <Grid item xs={7} style={{ margin: "0 auto" }}>
          <Typography
            variant="h5"
            style={{ fontWeight: 800, textAlign: "left", marginBottom: 10 }}
          >
            Collaborating with {campaign.name}
          </Typography>
          <div style={descriptionStyle}>
            <Typography
              variant="h7"
              component="p"
              style={{ textAlign: "left", paddingTop: 15, whiteSpace: "pre-wrap", wordWrap: "break-word" }}
            >
              {Array.isArray(campaign.deliverables) ? campaign?.deliverables?.join("\n")?.replaceAll("\\n", "\n") : campaign?.deliverables?.replaceAll("\\n", "\n")}
            </Typography>
            <Typography
              variant="h7"
              component="div"
              style={{ textAlign: "left", paddingTop: 15, whiteSpace: "pre-wrap", wordWrap: "break-word" }}

            >
              {campaign.talking_points && campaign.talking_points.replaceAll("\\n", "\n")}
            </Typography>
            <Typography
              variant="h7"
              component="div"
              style={{ textAlign: "left", paddingTop: 15, whiteSpace: "pre-wrap", wordWrap: "break-word" }}

            >
              <span style={{ fontWeight: "bold" }}>Deliverables:</span>  {Array.isArray(campaign.deliverables) ? campaign?.deliverables?.join("\n")?.replaceAll("\\n", "\n") : campaign?.deliverables?.replaceAll("\\n", "\n")}
            </Typography>
          </div>
          <Typography
            variant="h7"
            component="div"
            style={{ textAlign: "left", cursor: "pointer", fontWeight: "bold", paddingTop: ".5rem" }}
            onClick={handleToggleShowMore}
          >
            {!showMore ? "See more..." : "See less..."}
          </Typography>

          <Grid
            container
            sx={{
              margin: "0 auto",
              textAlign: "center",
            }}
            alignItems="center"
            justifyContent="center"
            style={{
              backgroundColor: "black",
              minHeight: 10,
              marginTop: 50,
              marginBottom: 50,
            }}
          ></Grid>

          <Typography
            variant="h5"
            style={{ fontWeight: 800, textAlign: "left", marginBottom: 10 }}
          >
            Creator Brief
          </Typography>
          {brief ?
            <a href={brief} target="_blank" rel="noreferrer" style={{ color: "black", textDecoration: "none", backgroundColor: "#F9F2FD", padding: "5px" }}>
              Click to open your brief
            </a> : <TextareaAutosize
              disabled
              fullWidth
              style={{
                minWidth: "100%",
                maxWidth: "100%",
                padding: 10,
                backgroundColor: "#fdf5e6",
                borderRadius: 6,
                cursor: "pointer",
                marginBottom: 20
              }}
              minRows={1}
              placeholder="There is currently no brief shared for this campaign."
            />
          }

          <Typography
            variant="h5"
            style={{ fontWeight: 800, textAlign: "left", marginBottom: 10 }}
          >
            Submit your concept
          </Typography>
          <TextareaAutosize
            value={newConceptLink}
            fullWidth
            style={{
              minWidth: "100%",
              maxWidth: "100%",
              padding: 10,
              borderRadius: 6,
            }}
            minRows={5}
            placeholder="Add your concept"
            onChange={(e) => { setNewConceptLink(e.target.value) }}
          />
          {newConceptLink != concept.link && <Button onClick={(e) => {
            handelUpdate("concept");
          }}>Update Concept</Button>}

          <div style={{ display: "flex", width: "100%", justifyContent: "space-between", marginTop: 25 }}>
            <Typography
              variant="h5"
              style={{
                fontWeight: 800,
                textAlign: "left",
                marginBottom: 10,
                marginTop: 10,
              }}
            >
              Submit your deliverables
            </Typography>
            <br/>
            <Button gradient style={{ width: "35%", borderRadius: 10 }} onClick={() => setDeliverableOpen(true)}>Submit New Deliverables</Button>
          </div>
          {
            deliverable.map((row, index) => {
              const fileUrl = row.file || row.link;
              return fileUrl ? <>
                <div style={{ display: "flex", width: "100%", justifyContent: "space-between", paddingTop: "2rem" }}>
                  <div style={{ width: "15%" }}>
                    <FileViewer url={fileUrl} />
                    <div style={{ width: "100%", textAlign: "center", cursor: "pointer", color: "blue", textDecoration: "underline", display: "flex", justifyContent: "center" }}><div onClick={() => { handleDownloadDeliverables(fileUrl, `${campaign.brand}_${user.name}_DeliverablesFile${index + 1}`) }}>File {index + 1}</div><Download /></div>
                  </div>
                  <div style={{ width: "85%", paddingLeft: "1em" }}>
                    <TextareaAutosize
                      disabled
                      fullWidth
                      style={{
                        minWidth: "100%",
                        maxWidth: "100%",
                        padding: 10,
                        backgroundColor: "#fdf5e6",
                        borderRadius: 6,
                        cursor: "pointer"
                      }}
                      minRows={4}
                      value={row.caption}
                    />
                    <div style={{ width: "100%", textAlign: "right", paddingTop: "1rem" }}><Button style={{
                      backgroundColor: '#e3e3e3',
                      border: '2px solid black',
                      color: 'black',
                      width: 250
                    }} onClick={(e) => assignEditableDeliverables({ ...row })}>Revise & Resubmit</Button></div>
                  </div>
                </div>
              </> : <div>
                <TextareaAutosize
                  value={newDeliverableLink || row.link}
                  fullWidth
                  style={{
                    minWidth: "100%",
                    maxWidth: "100%",
                    padding: 10,
                    borderRadius: 6,
                    marginTop: 20
                  }}
                  minRows={5}
                  placeholder="Add your deliverables"
                  onChange={(e) => { setNewDeliverableLink(e.target.value) }}
                />
                {newDeliverableLink && newDeliverableLink != row.link && <Button onClick={(e) => {
                  handelUpdate("draft", { ...row, link: newDeliverableLink });
                }}>Update Deliverables</Button>}
              </div>
            })
          }
          {/* <Typography
            variant="h5"
            style={{
              fontWeight: 800,
              textAlign: "left",
              marginBottom: 10,
              marginTop: 20,
            }}
          >
            Live Post Link
          </Typography>
          <Typography
            variant="body2"
            style={{
              textAlign: "left",
              marginBottom: 10,
              marginTop: 20,
            }}
          >
            Submit your live post link here once you've posted your content.
          </Typography>
          <br/>
          <Button sx={{
            backgroundColor: "#4158D0",
            backgroundImage: "linear-gradient(90deg, #0062ff, #da61ff)",
            marginBottom: 3
          }}
            onClick={(e) => setPostLinkModal(true)}
          >Add New Link</Button>
          {postLinkList.length > 0 && <div style={{ height: "400px", width: "100%" }}>
            <DataGrid
              rows={postLinkList}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 20 },
                },
              }}
              pageSizeOptions={[20, 50, 100]}
            /> </div>} */}
          {/* <Typography
            variant="h5"
            style={{
              fontWeight: 800,
              textAlign: "left",
              marginBottom: 5,
              marginTop: 10,
            }}
          >
            Additional Documents
          </Typography>
          {agreement && (
            <>
              Uploaded:{" "}
              <a href={agreement} target="_blank" rel="noreferrer">
                Document
              </a>
            </>
          )} */}
        </Grid>
        <Grid
          container
          sx={{
            margin: "0 auto",
            textAlign: "center",
          }}
          alignItems="center"
          justifyContent="center"
          style={{
            backgroundColor: "black",
            minHeight: 10,
            marginTop: 30,
            marginBottom: 30,
          }}
        ></Grid>
        <Grid item xs={12} style={{ marginLeft: 30 }}>
          <Typography
            variant="h5"
            style={{
              fontWeight: 800,
              textAlign: "left",
              marginBottom: 10,
              marginLeft: 20,
            }}
          >
            Submit Your Post Link & Analytics
          </Typography>
          <Typography
            style={{
              textAlign: "left",
              marginTop: 20,
              marginLeft: 20,
              paddingBottom: 20,
              width: "80%"
            }}
          >
           Submit your post links here once you have launched your content. Please ensure you have submitted for all channels you posted on, including story posts.
          </Typography>

          
          <div style={{ display: "flex", width: "100%", justifyContent: "space-between", marginTop: 20 }}>
          <Typography
            variant="body"
            style={{
              fontWeight: 800,
              textAlign: "left",
              marginBottom: 10,
              marginTop: 20,
              marginLeft: 20,

            }}
          >
            Submit your live post link
          </Typography>
            <br/>

            <Button gradient style={{
            marginBottom: 3,
            marginRight: 50,
            width: "20%", 
            borderRadius: 10, 
          }}
            onClick={(e) => setPostLinkModal(true)}
          >Submit Live Post Link</Button>
          {postLinkList.length > 0 && <div style={{ height: "400px", width: "100%" }}>
            <DataGrid
              rows={postLinkList}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 20 },
                },
              }}
              pageSizeOptions={[20, 50, 100]}
            /> </div>}
          </div>


          {/* <div style={{ display: "flex", gap: 25, flexDirection: "column", width: "95%" }}>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", alignContent: "center" }}>
              <Typography
                style={{
                  textAlign: "left",
                  marginTop: 20,
                  marginLeft: 20,
                  flex: 2
                }}
              >
                Select Post Platform
              </Typography>
              <div style={{ borderLeft: "2px solid grey", textAlign: "center", flex: 1.4 }}>
                <FormControl fullWidth variant="outlined">
                  <StyledSelect
                    value={newPostAnalytics.platform}
                    name="platform"
                    required
                    onChange={(e) => {
                      setNewPostAnalytics({ ...newPostAnalytics, [e.target.name]: e.target.value })
                    }}
                    displayEmpty
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return <em style={{ color: "grey" }}>Select platform</em>;
                      }
                      return valueToLabelMap[selected];
                    }}
                  >
                    {platforms.map((item) => (
                      <MenuItem value={item.value} key={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </StyledSelect>
                </FormControl>
              </div>
            </div>
            <div style={{ paddingLeft: 20 }}>
              <TableContainer component={Paper}>
                <StyledTable aria-label="simple table">
                  <TableBody>
                    {
                      TableFields.map((row) => {
                        return <StyledTableRow key={row.key}>
                          <StyledTableCell sx={{ width: "60%", fontWeight: "bolder" }} component="th" scope="row">{row.label}</StyledTableCell>
                          <StyledTableCell sx={{ width: "40%" }} align="right"><StyledTextField
                            type="number"
                            name={row.key}
                            value={newPostAnalytics[row.key]}
                            onChange={(e) => { setNewPostAnalytics({ ...newPostAnalytics, [e.target.name]: parseInt(e.target.value) }) }}
                            variant="outlined"
                            placeholder="0"
                            size="small"
                          /></StyledTableCell>
                        </StyledTableRow>
                      })
                    }

                  </TableBody>
                </StyledTable>
              </TableContainer>
            </div>
            <div style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
              <Button type="submit" sx={{ padding: ".8rem 4rem", fontWeight: "bolder" }} onClick={() => { handleSubmitAnalytics() }}>Submit</Button>
            </div>

          // </div> */}

        </Grid>
        {/* <Grid
          container
          sx={{
            margin: "0 auto",
            textAlign: "center",
          }}
          alignItems="center"
          justifyContent="center"
          style={{
            backgroundColor: "black",
            minHeight: 10,
            marginTop: 100,
            marginBottom: 30,
          }}
        ></Grid>
        <Grid item xs={8} style={{ marginLeft: 50 }}>
          <Typography
            variant="h5"
            style={{
              fontWeight: 800,
              textAlign: "left",
              marginTop: 20,
              marginBottom: 10,
            }}
          >
            Content Review Center
          </Typography>
          <Typography
            variant="h7"
            style={{
              textAlign: "left",
              marginTop: 20,
              marginBottom: 10,
            }}
          >
            See brand approvals, notes, and feedback
          </Typography>
          <div className="row">
            <Typography
              variant="body"
              style={{ textAlign: "left" }}
            >
              Concept Approval
            </Typography>
            {
              approveConcept ? <Button style={{ width: "30%", backgroundColor: "#4158D0", backgroundImage: "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)", color: "white" }} >Approved</Button> : <Button style={{ width: "30%" }}>Pending</Button>
            }
          </div>
          <div className="row">
            <Typography
              variant="body"
              style={{ textAlign: "left" }}
            >
              Content Approval
            </Typography>
            {
              approveContent ? <Button style={{ width: "30%", backgroundColor: "#4158D0", backgroundImage: "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)", color: "white" }} >Approved</Button> : <Button style={{ width: "30%" }}>Pending</Button>
            }
          </div>
          {
            feedbackList.length > 0 && <>
              <Typography
                variant="body"
                style={{
                  fontWeight: 800,
                  textAlign: "left",
                  marginTop: 20,
                  marginBottom: 10,
                }}
                className="row"
              >
                Brand Feedback & Notes
              </Typography>
              {
                feedbackList.map((data) => <>
                <div style={{marginBottom:20}}>
                  <TextareaAutosize minRows={5} style={{width:"100%"}}disabled value={data.feebback}></TextareaAutosize>
                  <div className="right-content">
                    <Typography>
                      {convertDate(data.submittedAt)}
                    </Typography>

                  </div>
                  </div>
                </>)
              }
            </>
          }
        </Grid> */}

        <Grid
          container
          sx={{
            margin: "0 auto",
            textAlign: "center",
          }}
          alignItems="center"
          justifyContent="center"
          style={{
            backgroundColor: "black",
            minHeight: 10,
            marginTop: 100,
            marginBottom: 30,
          }}
        ></Grid>

        <Grid item xs={8} style={{ marginLeft: 30 }}>
          <Typography
            variant="h5"
            style={{
              fontWeight: 800,
              textAlign: "left",
              marginBottom: 10,
              marginLeft: 20,
            }}
          >
            Your Affiliate Product Tracking Link
          </Typography>
          {products.length > 0 ? products.map((product) => (

            <TextField
              key={product.id}
              sx={{ width: "70%", marginLeft: 2, marginTop: 5 }}
              value={`https://giglgroup.com/product/${product.id}`}
            >
            </TextField>
          )) : <Typography
            variant="h7"
            style={{
              textAlign: "left",
              marginTop: 20,
              marginLeft: 20,
              marginBottom: 100
            }}
          >
            There is currently no affiliate link shared for this campaign.
          </Typography>}
        </Grid>
        <br/>

        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
      </Grid>
      {/* <Analytics
        campaignId={campaignId}
        creatorId={user.userDocId}
      /> */}
    </Box>
  );
}

